import{handlers as e}from"@sbu/hooks.entitytypes/build/mocks";var o=[...e];export{o as handlers};
//# sourceMappingURL=index.js.map
